
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cloud/[page]",
      function () {
        return require("private-next-pages/cloud/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cloud/[page]"])
      });
    }
  